import React from 'react';
import { FileText, Calendar, MessageSquare, Coins, ChevronRight } from 'lucide-react';

const ReportCard = ({ report, onClick, isSelected = false }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return (
    <button
      onClick={() => onClick(report)}
      className={`w-full text-left p-4 rounded-xl border transition-colors ${
        isSelected
          ? 'dark:bg-sky-500/10 bg-sky-50 dark:border-sky-500/30 border-sky-200'
          : 'dark:bg-slate-900 bg-white dark:border-slate-800 border-slate-200 hover:dark:border-slate-700 hover:border-slate-300'
      }`}
    >
      <div className="flex items-center gap-4">
        {/* Icon */}
        <div className={`p-2 rounded-lg ${
          isSelected
            ? 'dark:bg-sky-500/20 bg-sky-100'
            : 'dark:bg-slate-800 bg-slate-100'
        }`}>
          <FileText className={`w-5 h-5 ${isSelected ? 'text-sky-500' : 'dark:text-slate-400 text-slate-500'}`} />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <Calendar className="w-3.5 h-3.5 dark:text-slate-500 text-slate-400" />
            <span className="font-medium dark:text-white text-slate-900">
              {formatDate(report.date || report.created_at)}
            </span>
          </div>
          <div className="flex items-center gap-4 text-xs dark:text-slate-400 text-slate-500">
            <span className="flex items-center gap-1">
              <MessageSquare className="w-3 h-3" />
              {report.total_posts || 0} posts
            </span>
            <span className="flex items-center gap-1">
              <Coins className="w-3 h-3" />
              {report.credits_charged || 0} credits
            </span>
            {report.hot_leads_count > 0 && (
              <span className="px-1.5 py-0.5 rounded-full text-[10px] font-medium dark:bg-green-500/10 dark:text-green-400 bg-green-50 text-green-600">
                {report.hot_leads_count} hot leads
              </span>
            )}
          </div>
        </div>

        {/* Arrow */}
        <ChevronRight className={`w-5 h-5 flex-shrink-0 ${
          isSelected ? 'text-sky-500' : 'dark:text-slate-600 text-slate-400'
        }`} />
      </div>
    </button>
  );
};

export default ReportCard;
